export default "__VITE_ASSET__Kv4h9m6s__"